import React from 'react';
import { clsx } from 'clsx';
import { Icon } from '@/ui/icons/Icon';
import { formatAmountWithSpacesAndSymbol } from '@/lib/amountUtils';
import styles from './InstallmentDetails.module.scss';
import { Button } from '@/ui/components/Button/Button';

export interface InstallmentDetailsProps {
  creditAmount: number | undefined;
  monthlyPayment: number | undefined;
  period: number | undefined;
  className?: string;
  showEditIcons?: boolean;
  onEditPeriod?: () => void;
}

export const InstallmentDetails: React.FC<InstallmentDetailsProps> = ({
  creditAmount,
  monthlyPayment,
  period,
  className,
  showEditIcons = false,
  onEditPeriod,
}) => {
  return (
    <div className={clsx(styles.detailsSection, className)}>
      <div className={styles.sectionHeader}>
        <h3 className={styles.sectionTitle}>Detalii</h3>
      </div>

      <div className={styles.detailsCard}>
        {/* Credit Amount */}
        <div className={styles.detailRow}>
          <div className={styles.detailLeft}>
            <p className={styles.detailLabel}>Suma creditului</p>
          </div>
          <div className={styles.detailRight}>
            <div className={styles.detailValue}>
              <span className={styles.detailText}>
                {formatAmountWithSpacesAndSymbol(creditAmount, 'lei')}
              </span>
            </div>
          </div>
        </div>

        {/* Monthly Payment */}
        <div className={styles.detailRow}>
          <div className={styles.detailLeft}>
            <p className={styles.detailLabel}>Rata lunară</p>
          </div>
          <div className={styles.detailRight}>
            <div className={styles.detailValue}>
              <span className={styles.detailText}>
                {formatAmountWithSpacesAndSymbol(monthlyPayment, 'lei')}
              </span>
            </div>
          </div>
        </div>

        {/* Duration */}
        <div className={styles.detailRow}>
          <div className={styles.detailLeft}>
            <p className={styles.detailLabel}>Durata</p>
          </div>
          <div className={styles.detailRight}>
            <div className={styles.detailValue}>
              <span className={styles.detailText}>{period}</span>
              <span className={styles.detailUnit}>luni</span>
              {showEditIcons && (
                <Button
                  trackingId="edit_period_installment_details"
                  iconOnly
                  size="xsmall"
                  className={styles.editButton}
                  variant="outlined"
                  leftIcon={<Icon name="pen" className={styles.editIcon} />}
                  onClick={onEditPeriod}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
